import {BaseEntity} from "../../entities/BaseEntity";
import {PagingModel} from "../paging/PagingModel";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {IService} from "../../services/IService";
import {NotificationService} from "../../services/NotificationService";
import alasql from "alasql";

export class ExportModel<T extends BaseEntity> extends PagingModel<T>{
    assignedItems:any[] = [];
    selectedAssignedItems:any[] = [];
    constructor($q:ng.IQService,public cfnService:CustomFieldNameService,pagingService:IService, notifyService:NotificationService){
        super($q, pagingService, notifyService);
    }
    addItems(items:any){
        for(var i=0;i<items.length;i++){
            this.assignedItems.push(items[i]);
        }
    }
    removeItems(items:any){
        for(var i=0;i<items.length;i++){
            var index = this.assignedItems.indexOf(items[i]);
            this.assignedItems.splice(index,1);
        }
    }
    addAssignedSelected(item:any):void{
        var foundIndex = this.selectedAssignedItems.indexOf(item);
        if(foundIndex != -1)
            this.selectedAssignedItems[foundIndex] = item;
        else
            this.selectedAssignedItems.push(item);
        this.selectionChanged();
    }
    removeAssignedSelected(item:any):void{
        var foundIndex = this.selectedAssignedItems.indexOf(item);
        if(foundIndex != -1)
            this.selectedAssignedItems.splice(foundIndex,1);
        this.selectionChanged();
    }
    doExport() {
        var selSql = this.cfnService.getOtherReportSql(this.assignedItems)
        alasql('SELECT ' + selSql + ' INTO CSV("export.csv",{headers:true,separator:","}) FROM ?', [this.assignedItems]);
    }
    getExportType(){
        return "";
    }
}
